/* eslint-disable react/prop-types */
import clsx from "clsx";
import React, { FunctionComponent } from "react";

type Props = {
  className?: string;
};

export const MazdaLogo: FunctionComponent<Props> = ({ className }) => (
  <img
    alt="Mazda Logo"
    className={clsx("block", className)}
    src="/static/img/mazda_v2/logo.png"
  />
);
